// ── 일일콜 목록 결과 ✎ 수정·지우기 (2026-11-03) ──────────────────────────────
// 직원 화면(adminMode=false): 결과 저장 주소 PATCH /api/tm/feedback/:id — 콜 주인·담당 마케터만, '미팅인계' 검사 포함(서버).
// 관리 화면: 그 화면의 콜 저장 주소 PUT {callsUrl}/:id — 본사 관리 모드는 남의 콜도, 통합 메뉴는 메뉴 회사 콜 모두.
// 창을 열 때 '/api/tm/calls' 줄기면 GET …/keep-actions 의 feedback 으로 막을지 정한다(못 물어보면 막음 — 저장도 같은 주소).
//   통합 메뉴는 메뉴를 받은 사람이 메뉴 회사 콜을 모두 고칠 수 있어 묻지 않는다(킵 해제 창과 같은 방식).
// 지우기 = 결과·메모를 비운다 → 상담자의 🔔 피드백 대기로 돌아간다(refreshKey 로 대기 숫자 다시 세기).
import { useState } from 'react';
import { apiClient } from '../../../api/apiClient';

export function useFeedbackEdit({ adminMode, callsUrl = '/api/tm/calls', showToast, fetchList }) {
  const [target, setTarget] = useState(null);
  const [canEdit, setCanEdit] = useState(true);
  const [saving, setSaving] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  async function open(row) {
    const id = Number(row?.id);
    if (!Number.isInteger(id) || id <= 0) return;
    let ok = true;
    if (callsUrl === '/api/tm/calls') {
      const a = await apiClient.get(`${callsUrl}/${id}/keep-actions`);
      ok = Boolean(a.ok && a.data?.actions?.feedback);
    }
    setCanEdit(ok);
    setTarget(row);
  }

  async function send(feedback, memo, doneText) {
    const id = Number(target?.id);
    const body = { feedback: feedback || '', feedback_memo: feedback ? String(memo || '').trim() : '' };
    setSaving(true);
    const r = adminMode
      ? await apiClient.put(`${callsUrl}/${id}`, body)
      : await apiClient.patch(`/api/tm/feedback/${id}`, body);
    setSaving(false);
    if (!r.ok) { showToast(r.data?.message || '결과 저장에 실패했습니다.', 'error'); return; }
    showToast(doneText, 'success');
    setTarget(null);
    fetchList?.();
    setRefreshKey((k) => k + 1);
  }

  async function save(feedback, memo) {
    if (!feedback) { showToast('피드백을 선택해 주세요.', 'error'); return; }
    await send(feedback, memo, `${target?.company_name || '미팅'} 결과를 고쳤습니다.`);
  }

  const remove = () => send('', '', `${target?.company_name || '미팅'} 결과를 지웠습니다.`);
  const close = () => setTarget(null);

  return { target, canEdit, saving, refreshKey, open, close, save, remove };
}
